export const TRAVELLER_ENDPOINT = `https://${process.env.NEXT_PUBLIC_TRAVELLER_GATEWAY_DOMAIN_NAME}`;
